export const FUTURE_EXIT_TABLE_NAMES = {
  FUTURE_EQUITY_VALUE: 'futureEquityValue',
  MODIFIED_PRESENT_EQUITY_VALUE: 'modifiedPresentEquityValue',
  ALLOCATION_METHOD_VALUE: 'allocationMethodValue',
};

export const CSE_METHOD = 'CSE';
export const OPM_METHOD = 'OPM';
export const CSE = 1;
export const OPM = 2;

export const ALLOCATION_METHODS_VALUE = {
  [CSE_METHOD]: CSE,
  [OPM_METHOD]: OPM,
};

export const SCENARIO_VALUES_PARAMS = {
  SCENARIO_METHOD: 'scenarioMethod',
  CAPTABLE_ID: 'captableId',
  EXIT_DATE: 'exitDate',
  DISCOUNT_RATE: 'discountRate',
  EQUITY_VALUE: 'equityValue',
  MATURITY: 'maturity',
  VOLATILITY: 'volatility',
} as const;

export const REQUIRED_SCENARIO_VALUES_PARAMS = [
  SCENARIO_VALUES_PARAMS.SCENARIO_METHOD,
  SCENARIO_VALUES_PARAMS.CAPTABLE_ID,
  SCENARIO_VALUES_PARAMS.EXIT_DATE,
  SCENARIO_VALUES_PARAMS.DISCOUNT_RATE,
  SCENARIO_VALUES_PARAMS.EQUITY_VALUE,
];

export const REQUIRED_OPM_SCENARIO_VALUES_PARAMS = [SCENARIO_VALUES_PARAMS.MATURITY, SCENARIO_VALUES_PARAMS.VOLATILITY];

// A 0% discount rate is valid: present values then equal future values
export const ZERO_ALLOWED_SCENARIO_VALUES_PARAMS: string[] = [
  SCENARIO_VALUES_PARAMS.SCENARIO_METHOD,
  SCENARIO_VALUES_PARAMS.DISCOUNT_RATE,
];
